export const validationRules = { SERIAL_NUMBER_LENGTH: 12 };

export const ERROR_TEXT = {
  REQUIRED: 'Поле обязательно для заполнения',
  SERIAL_NUMBER_EMPTY: 'Серийный номер пустой',
  MANUFACTURER_EMPTY: 'Производитель пустой',
  SERIAL_NUMBER_LENGTH: `Серийный номер должен состоять из ${validationRules.SERIAL_NUMBER_LENGTH} символов`,
  LOCATION_EMPTY: 'Заполните место установки',
};
